/**
 * FH-A11Y batch 17 (2026-09-26): collection cards, quick add (Globo product cards).
 * The size / colour choices and Add to cart only appeared on mouse hover, and the choices were
 * plain text or pictures that react to clicks only, so keyboard and screen reader users couldn't
 * use them. Now:
 *  - Tabbing into a card opens the same panel the mouse hover opens.
 *  - Each row of choices is a radio group ("Size for <product>", "Color for <product>"): Tab reaches
 *    the selected choice, arrow keys move and choose, Space / Enter choose. Sold-out choices say so.
 *  - Add to cart is named with the product and the chosen options.
 * Rollback: remove the ada-a11y-batch17.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch17) return;
  window.__fhA11yBatch17 = true;

  var CARD = '.spf-product-card';
  var OPEN = 'fh-kbd-open';

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function setAttr(el, n, v) { if (el.getAttribute(n) !== v) el.setAttribute(n, v); }
  function say(msg) { if (typeof window.fhA11yAnnounce === 'function') window.fhA11yAnnounce(msg, 300); }

  /* 1. Copy the theme's "card:hover" styles so they also apply while the card has keyboard focus. */
  var cssDone = false;
  function copyHoverCss() {
    if (cssDone) return;
    var out = [];
    var re = /(\.spf-product-card(?:[.\w-]*)?):hover/g;
    Array.prototype.forEach.call(document.styleSheets, function (ss) {
      var rules;
      try { rules = ss.cssRules; } catch (e) { return; }
      if (!rules) return;
      Array.prototype.forEach.call(rules, function (r) {
        var s = r.selectorText;
        if (!s || s.indexOf('spf-product-card') < 0 || !re.test(s)) return;
        re.lastIndex = 0;
        out.push(r.cssText.replace(re, '$1.' + OPEN));
        re.lastIndex = 0;
      });
    });
    if (!out.length) return;
    cssDone = true;
    out.push('.spf-product-card .spf-product__swatch:focus-visible{outline:2px solid #10728b;outline-offset:2px;}');
    out.push('.spf-product-card button.spf-product__form-btn-addtocart:focus-visible{outline:2px solid #10728b;outline-offset:2px;}');
    var st = document.createElement('style');
    st.id = 'fh-a11y-batch17-css';
    st.textContent = out.join('\n');
    document.head.appendChild(st);
  }

  function title(card) { return txt(card.querySelector('.spf-product-card__title a, .spf-product-card__title')); }
  function groupName(g) {
    var sws = g.querySelectorAll('.spf-product__swatch');
    if (g.querySelector('.spf-product__swatch-image')) return 'Color';
    var t = sws.length ? txt(sws[0]) : '';
    if (/\d/.test(t) && /(['"x×]|round|runner|square|ft|cm)/i.test(t)) return 'Size';
    return 'Option';
  }
  function swName(s) {
    return (s.getAttribute('data-option-value') || s.getAttribute('title') || txt(s)).trim();
  }

  /* 2. Choices as radio groups. */
  function fixCard(card) {
    var t = title(card);
    if (!t) return;
    var groups = card.querySelectorAll('.spf-product__swatchs');
    var chosen = [];
    Array.prototype.forEach.call(groups, function (g) {
      var sws = g.querySelectorAll('.spf-product__swatch');
      if (!sws.length) return;
      var name = groupName(g);
      setAttr(g, 'role', 'radiogroup');
      setAttr(g, 'aria-label', name + ' for ' + t);
      var sel = null;
      Array.prototype.forEach.call(sws, function (s) {
        var on = s.classList.contains('is-selected');
        if (on) sel = s;
        setAttr(s, 'role', 'radio');
        setAttr(s, 'aria-checked', on ? 'true' : 'false');
        var v = swName(s);
        setAttr(s, 'aria-label', v + (s.classList.contains('soldout') ? ', sold out' : ''));
        s.querySelectorAll('.spf-product__swatch-inner, .spf-product__swatch-text, .spf-product__swatch-image')
          .forEach(function (i) { setAttr(i, 'aria-hidden', 'true'); });
      });
      Array.prototype.forEach.call(sws, function (s) {
        setAttr(s, 'tabindex', (sel ? s === sel : s === sws[0]) ? '0' : '-1');
      });
      if (sel) chosen.push(swName(sel));
      if (!g.__fh17) {
        g.__fh17 = true;
        g.addEventListener('keydown', onKey);
        g.addEventListener('click', function () { setTimeout(function () { fixCard(card); }, 50); });
      }
    });
    var btn = card.querySelector('button.spf-product__form-btn-addtocart');
    if (btn) {
      var bt = txt(btn);
      var what = t + (chosen.length ? ', ' + chosen.join(', ') : '');
      setAttr(btn, 'aria-label', /add to cart/i.test(bt) ? 'Add ' + what + ' to cart' : bt + ': ' + what);
    }
  }

  function onKey(e) {
    var s = e.target.closest && e.target.closest('.spf-product__swatch');
    if (!s) return;
    var g = s.closest('.spf-product__swatchs');
    var list = Array.prototype.slice.call(g.querySelectorAll('.spf-product__swatch'));
    var i = list.indexOf(s);
    var j = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % list.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + list.length) % list.length;
    else if (e.key === 'Home') j = 0;
    else if (e.key === 'End') j = list.length - 1;
    else if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') j = i;
    if (j < 0) return;
    e.preventDefault();
    choose(list[j]);
  }

  function choose(s) {
    var card = s.closest(CARD);
    s.click();
    try { s.focus({ preventScroll: true }); } catch (err) { s.focus(); }
    setTimeout(function () {
      fixCard(card);
      var price = txt(card.querySelector('.spf-product-card__price-wrapper'));
      var btn = card.querySelector('button.spf-product__form-btn-addtocart');
      var bt = txt(btn);
      say(swName(s) + ' selected.' + (price ? ' ' + price + '.' : '') + (/sold out|unavailable/i.test(bt) ? ' ' + bt + '.' : ''));
    }, 150);
  }

  /* 3. Open the hover panel while a card has keyboard focus. */
  document.addEventListener('focusin', function (e) {
    var card = e.target.closest && e.target.closest(CARD);
    document.querySelectorAll(CARD + '.' + OPEN).forEach(function (c) { if (c !== card) c.classList.remove(OPEN); });
    if (!card) return;
    var kbd = true;
    try { kbd = e.target.matches(':focus-visible'); } catch (err) {}
    if (!kbd || card.__fh17closed) return;
    copyHoverCss();
    fixCard(card);
    card.classList.add(OPEN);
  }, true);
  document.addEventListener('focusout', function (e) {
    var card = e.target.closest && e.target.closest(CARD);
    if (card && (!e.relatedTarget || !card.contains(e.relatedTarget))) {
      card.classList.remove(OPEN);
      card.__fh17closed = false;
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var card = e.target.closest && e.target.closest(CARD + '.' + OPEN);
    if (!card) return;
    card.classList.remove(OPEN);
    card.__fh17closed = true;
    var link = card.querySelector('.spf-product-card__title a');
    if (link && link !== e.target) { try { link.focus({ preventScroll: true }); } catch (err) { link.focus(); } }
  }, true);

  function runAll() {
    document.querySelectorAll(CARD).forEach(function (c) { try { fixCard(c); } catch (e) {} });
  }
  var timer = 0;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = 0; runAll(); }, 120);
  }
  function start() {
    runAll();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
